var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Grid } from '@mui/material';
import React from 'react';
export var BoxContainerLayout = function (_a) {
    var children = _a.children, maxWidth = _a.maxWidth;
    return (_jsx(Box, { children: _jsx(Grid, __assign({ container: true, justifyContent: "center", sx: {
                maxWidth: maxWidth || '1152px',
                margin: 'auto',
                paddingTop: 0
            } }, { children: children })) }));
};
